module.exports = __webpack_public_path__ + "static/media/trash-icon.769ab890.svg";